import script from "./categoriesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./categoriesPage.vue?vue&type=script&setup=true&lang=js"

import "./categoriesPage.vue?vue&type=style&index=0&id=11da88f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11da88f8"]])

export default __exports__